import * as React from 'react';
const SvgGirlSwordBuildingAlleyOpt = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlSpace='preserve'
    width='300mm'
    height='200mm'
    viewBox='0 0 300 200'
    {...props}
  >
    <g
      style={{
        display: 'inline',
        opacity: 0.7,
      }}
    >
      <path
        d='m181.967 113.112-.105-6.728 9.987-.526m-9.567 21.656v-4.52m1.052 21.865L98.92 112.27m87.883 27.752-87.147-27.962m85.57 15.768-85.78-15.979m194.262 35.551-82.063-15.162m82.688 41.11-81.75-25.166m81.478 40.184-87.61-34.486M1.497 198.679l97.38-86.496m23.288-9.312.066-39.186 8.612-4.606 9.146 3.338-.468 34.18M22.387 179.87l.772-82.822 36.835 7.058.22 42.018M164.59 82.674l9.671-.095m99.628-46.115 10.136 3.262M3.198 197.186l96.056-84.808m58.13-23.541 7.3-5.973 5.31 1.232m18.582-14.885 21.427-.758m-32.709 12.799c1.232-.569 11.377-11.567 11.377-11.567l16.118 1.612M85.962 123.64c.047-.474-.095-14.722-.095-14.722l4.07.71-.094 10.462m44.288-49.134-.064 19.588m-4.346-18.874.065 20.56m-31.253 17.955-82.215-93.35M97.873 109.6 17.272 17.485M82.13 94.897l11.002.058.058-1.412-10.53-3.706-.118 2.06m16.834 15.938-.106 4.628m-6.252-2.82 4.634-.14-4.192-1.946-.548.053zm2.246 5.537-.035-2.777.583-.018.018 2.194m1.256-2.176 1.061-.53m6.227.175-.837-.101m2.714.704c.033-.235 0-1.274 0-1.274l-.67.034-.034 1.14m8.042-4.29.067 1.207 1.508-.37-.067-1.172zm-.302 5.797c-.033-.134-.067-2.815-.067-2.815l1.81-.234-.067 3.384m26.805 5.026.034-10.99 8.343-.235v12.9m81.682-19.23 34.802-2.196m-34.918-.694 35.497-2.89m-34.919 39.774c.116-.462-.231-39.08-.231-39.08l35.034-3.7-.231 49.255m-44.516-7.978-.347-42.665 66.831-10.637-.115 65.096M144.676 98.122l.102 3.063m-2.127-2.506 4.354-1.747.026 4.076-4.507.962zm19.733-6.043.108 3.258m-3.53-2.064 7.576-2.172.081 3.638-7.575 1.44zm30.113-9.718-.064 6.396M183 86.03l13.048-3.773v6.972l-12.984 2.558zm63.387-20.66.448 12.217m-13.305-7.995.128 11.002m-9.722-7.996.192 9.978m-2.179.797 29.058-6.584m-28.93-3.545 26.27-8.23m26.21-28.107v8.04m-54.38 15.066.127 5.381m-8.04-5.76c.253 0 8.166.063 8.166.063l54.633-23.107-14.434-.95zM69.943 84.539l-.079 8.055m-23.049-22.41.24 15.87m-12.681-25.68c-.24.319.16 19.46.16 19.46m259.168-43.399L99.816 111.56m-.682 79.413.286-79.106m-16.308 79.822 16.022-79.107M66.009 80.936l7.503 6.362-.146 7.54-7.202-3.926Zm-41.384-28.29 29.72 22.715-.212 14.86-29.296-14.435Z'
        style={{
          opacity: 1,
          fill: 'none',
          fillOpacity: 1,
          stroke: props.stroke || 'tan',
          strokeWidth: 0.899999,
          strokeDasharray: 'none',
          strokeOpacity: 1,
        }}
      />
    </g>
    <path
      d='m78.912 154.283-2.527.372-1.327-.143-.857-.543-.243-.756 1.285-.129.97-.37 2.499-1.257zm-.842-2.983.414-.814.856-.114 1.028 1 .428 1.94.129 1.57-.714.472-1.485-.614m3.966-5.029 1.26-.945 1.339 1.418-.08.63-1.338.788m-13.388-18.193-22.76 29.848-4.174 2.284 1.181-4.489 21.028-30.163m-.394-4.41.787 1.339 5.434 3.386 2.836.158.078 2.52-2.126.079-3.465-1.497-5.04-3.15.236-2.126zm2.835 2.126c.157-.315 9.214-10.553 9.214-10.553l1.654-.315.473 1.97-8.585 10.395'
      style={{
        display: 'inline',
        opacity: 1,
        fill: 'none',
        fillOpacity: 1,
        stroke: props.stroke || 'tan',
        strokeWidth: 0.7,
        strokeDasharray: 'none',
        strokeOpacity: 1,
      }}
      transform='translate(132.085 -6.123)'
    />
    <path
      d='m72.986 142.873.73 1.55.365 1.322.547 1.87.455 2.37.365 2.325m-11.944-8.753 1.14.182 2.097.182 2.462-.045 1.914-.137 1.322-.228.821-1.14.866-2.051.274-1.55.273-1.778m-16.366 13.266-1.23 2.188-.821 1.095-1.231 1.413 1.413 1.185 3.374.684 4.832.592h2.142l4.149-.82 3.373-1.049.958-.82m-15.591-23.843c-.046.183 0 2.234 0 2.234l.319 1.413.82 1.824.32.41m-3.647-9.209-2.325 2.827-1.095 2.188-.638 1.276 2.082 1.74 2.551 1.002 1.309-1.207.395-.85m16.275-9.893.501 1.276.684 2.188 1.094 1.87 1.186 1.595-.456 1.049-1.824 1.185-2.325.684-1.915.273m-6.655-11.716c.228.046 2.097.228 2.097.228l1.458-.501 1.915-1.231.137 2.097-1.778 1.413-3.647.182-1.368-.273-.228-.958zM66.366 171.653l.793.476 1.164.581 2.062.265 1.64-.265.687-.158-1.11 2.697-1.005 2.273-.74 3.385v1.956l.316 2.01.9 1.428 1.11 1.057.899.318.476.581-.106.688-1.322.846-1.375.476-1.428.423-1.903-.053-1.375-.211-.37-.212.581-2.591.318-1.534.052-3.12-.423-2.485-.528-3.543v-2.486l.211-2.062zm-9.677-.423 1.269.951 1.64.212 1.744-.106 1.692-.529.476-.052-.634 2.273-1.48 3.12-1.376 3.86-.687 2.645-.159 1.745 1.164.211h1.957l.264 1.428-.16 1.164-3.013 1.745-2.116.105-2.326-.423-.318-.634 1.005-2.803.476-3.649.529-2.961.158-1.957-.317-4.389-.158-1.64z'
      style={{
        opacity: 1,
        fill: 'none',
        fillOpacity: 1,
        stroke: props.stroke || 'tan',
        strokeWidth: 0.7,
        strokeDasharray: 'none',
        strokeOpacity: 1,
      }}
      transform='translate(132.085 -6.123)'
    />
    <g
      style={{
        display: 'inline',
      }}
    >
      <path
        d='M74.827 155.56c-.038.154-.27 2.74-.27 2.74l-.193 1.659-.656 2.547-.501 1.66-.54 1.813-.116 1.698.154 1.428-.116 1.505-.154 1.543m-6.56-14.317c-.078.193-.155 2.702-.155 2.702l.116 1.93.193 1.388.501 2.277.464 1.197.231 1.119.309 1.273-.347 1.042-.31.656m3.438-50.393.183 1.157m-7.402 49.43.038-1.236.31-1.466.154-1.235.115-1.428.927-2.431.964-2.702m-6.869-4.322c.039.193-.154 1.467-.154 1.467l-.193 1.312-.039 1.968v1.736l.039 1.698.038 2.2-.231.926-.695 1.737-.424 1.158m24.063-17.21.948-.076.872-.645.455-.834-.455-1.782-.644-.948-1.251-1.061m-3.261-14.94.379.418.645 1.289.568 2.01.114 1.175.341.607.493 1.061.228 3.223.19 2.085.227 2.351.076.91m-5.915-14.067-.152 1.062.19.872.493 1.44.492 1.1.342.683-.038 1.934.113.53.835 1.972.606 1.251.834 1.934.455.986.228.948.19.682.113.569m-22.332-14.143L56 137.596l-1.365.758-.834.493 1.024.038 1.213.569.91 1.402.455.91m-3.943-7.469-1.896 3.147-.834 1.555-.152.985.266 1.024.986.986 1.706 1.289 1.175.72.91.645'
        style={{
          opacity: 1,
          fill: 'none',
          fillOpacity: 1,
          stroke: props.stroke || 'tan',
          strokeWidth: 0.7,
          strokeDasharray: 'none',
          strokeOpacity: 1,
        }}
        transform='translate(132.085 -6.123)'
      />
    </g>
    <path
      d='m60.148 112.383.427-1.462 1.339-1.704 1.644-.974 2.07-.548 1.765-.122 1.461.122 1.644.487 1.217.974 1.035 1.218.853 1.948.243 2.07-.243 2.435-1.157 2.07-1.766 1.948-2.07 1.278-1.278.609-1.826.913-1.522.913-2.679 1.096-2.435 1.035-2.679.913-3.287.913-2.983.548-2.679.548-1.461.061 2.496-.913 2.07-1.096 1.34-.913-3.897-.122-2.557-.791-2.192-1.279-.791-.73-.73-.73 2.313.425 2.679.122 2.374-.243 2.07-.487 1.156-.73-2.678.06-2.07-.304-1.522-.366-1.34-.426-.79-.609-.488-.548.852-.243 1.583.183h2.131l2.009-.244 2.192-.852 2.009-.974 2.313-1.583 1.887-1.644 1.157-1.157z'
      style={{
        opacity: 1,
        fill: 'none',
        fillOpacity: 1,
        stroke: props.stroke || 'tan',
        strokeWidth: 0.7,
        strokeDasharray: 'none',
        strokeOpacity: 1,
      }}
      transform='translate(132.085 -6.123)'
    />
  </svg>
);
export default SvgGirlSwordBuildingAlleyOpt;
